import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';

import { HttpBackendClient } from './../services/httpbackend-client';
// import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';

import {TranslateService} from '@ngx-translate/core';
import { HelperService } from './../services/helper.service';
import { GalleryService } from '../rest/api/gallery.service';
import { StatisticsService } from '../rest';
import { Meta, Title } from '@angular/platform-browser';

import { environment } from '../../environments/environment';

@Component({
  selector: 'app-space-details',
  templateUrl: './space-details.component.html',
  styleUrls: ['./space-details.component.scss']
})
export class SpaceDetailsComponent implements OnInit, OnDestroy {
  highLightReelData: any;
  spaceId: any;
  languageData: any;
  galleryList: any;
  galleryDetail: any;
  lang: any;
  pageLoader = true;
  virtualLoader = true;
  spaceData: any;
  mediaData: any;
  floorplanData: any;
  selectedMedia: any;
  ipAddress: string;
  uniqueVisitors: any;
  title: any;
  seoTitle: any;
  seoDescription: any;
  seoKeyword: any;
  seoMedia: any;
  createdBy: any;
  bspaceUrl: any;
  itemsPerPage = 6;
  currentPage = 1;
  categoryId = '';
  keywords = '';
  visitors: any;

  isIframeEnabled = false;
  iframeCode: any;

  sessionInterval: any;
  sessionTime = 0;

  // User inactivity
  userActivity;
  userInactive: Subject<any> = new Subject();
  sessionEnded = false;
  // @HostListener('window:unload', ['$event'])
  // unloadHandler(event) {
  //   console.log('window:unload');
  //   this.storeSessionVistorsCount();
  // }

  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHander(event) {
  //   console.log('window:beforeunload');
  //   this.storeSessionVistorsCount();
  // }
  constructor(
    private route: ActivatedRoute,
    public galleryService: GalleryService,
    public translateService: TranslateService,
    private http: HttpBackendClient,
    private statisticService: StatisticsService,
    public router: Router,
    public helperService: HelperService,
    private meta: Meta,
    private titleService: Title
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
        return false;
    };
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
         // trick the Router into believing it's last link wasn't previously loaded
         this.router.navigated = false;
         // if you need to scroll back to top, here is the right place
         window.scrollTo(0, 0);
      }
    });

    this.setTimeoutForUserInactive();
    // If user is inactive then call post api for storing sessions
    this.userInactive.subscribe(() => {
      console.log('session ended');
      this.storeSessionVistorsCount();
    });
    this.bspaceUrl = environment.baseUrl;
  }

  setTimeoutForUserInactive() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 1000 * 60 * 30);
  }

  @HostListener('window:mousemove') refreshUserState() {
    if (!this.sessionEnded) {
      clearTimeout(this.userActivity);
      this.setTimeoutForUserInactive();
    }
  }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getAllGalleryList(this.currentPage, this.itemsPerPage, this.categoryId, this.keywords);
    this.route.params.subscribe(params => {
      this.spaceId = params.id;
      if (!params.id) {
        this.router.navigate(['/']);
      }
      this.getAllSpaceDetails(this.spaceId);
    });
    this.http.get<{ip: string}>('https://jsonip.com').subscribe(data => {
      this.ipAddress = data && data.ip;
      this.startSession();
      this.trackIpAddress();
    });
  }

  async trackIpAddress() {
    const body = {
      ip: await this.ipAddress,
      space_id: await this.spaceId,
      type: 'visitor'
    };
    let formData;
    formData = body;
    formData = this.helperService.updateJsonFormat(formData);
    this.statisticService.getIpDetail(formData).subscribe((res: any) => {
      this.uniqueVisitors = res && res.data;
    }, err => {
      console.log(err);
    });
  }

  getAllGalleryList(page, limit, categoryId, keywords) {
    const thisobject = this;
    this.galleryService.getGalleryList({
      page: page,
      paginate: limit,
      category: categoryId || undefined,
      keywords: keywords || undefined,
      lang: this.lang
    }).subscribe((response: any) => {
      let galleryList;
      galleryList = response.data;
      galleryList = _.orderBy(galleryList, ['published_date'], ['desc']);
      this.galleryList = _.filter(galleryList, (gallery) => {
        return this.spaceId !== gallery.uuid;
      });
    }, err => {
      thisobject.pageLoader = false;
      this.galleryList = [];
    });
  }


  setTitle() {
    this.seoTitle = this.spaceData && this.spaceData.title ? this.spaceData.title : 'Bspace';
    this.createdBy = this.spaceData && this.spaceData.created_by ? this.spaceData.created_by : 'Bspace';
    this.seoDescription = this.spaceData && this.spaceData.summary ? this.spaceData.summary : 'This is description';
    this.seoKeyword = this.spaceData && this.spaceData.seo_keywords ? this.spaceData.seo_keywords : 'virtual tours,scenes,news';

    this.meta.updateTag({ name: 'title', content: this.seoTitle });
    this.meta.updateTag({ name: 'description', content: this.seoDescription });
    this.meta.updateTag({ name: 'keywords', content: this.seoKeyword });
    this.meta.updateTag({ name: 'author', content: this.createdBy });

    this.meta.addTag({ property: 'og:url', content: `${this.bspaceUrl}/scenes/${this.spaceData.uuid}`});
    this.meta.addTag({ property: 'og:type', content: 'article' });
    this.meta.addTag({ property: 'og:site_name', content: 'Bspace' });
    this.meta.addTag({ property: 'og:image:width', content: '620' });
    this.meta.addTag({ property: 'og:image:height', content: '541' });
    this.meta.addTag({ property: 'og:title', content: this.getDescription(this.seoTitle.slice(0, 45)) });
    this.meta.addTag({ property: 'og:description', content: this.getDescription(this.seoDescription.slice(0, 145)) });

    if (this.spaceData.image && this.spaceData.image !== '') {
      this.meta.addTag({ property: 'og:image', content: this.spaceData.image });
      this.meta.addTag({ property: 'twitter:image', content: this.spaceData.image });
    }

    this.meta.addTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.addTag({ name: 'twitter:title', content: this.getDescription(this.seoTitle.slice(0, 45)) });
    this.meta.addTag({ name: 'twitter:description', content: this.getDescription(this.seoDescription.slice(0, 145)) });

  }

  getDescription(description) {
    if (description && description !== '') {
      return description.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, '').replace(/<\/?[^>]+(>|$)/g, '')
      .replace('&lsquo;', '').replace('&rsquo;', '').replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
    }
  }

  getAllSpaceDetails(id) {
    this.galleryService.getGalleryDetails(id).subscribe((response: any) => {
      this.iframeCode = `<iframe width="853" height="480" src="${environment.baseUrl}/scenes/iframe/${id}" frameborder="0" allowfullscreen allowvr></iframe>`;
      this.pageLoader = false;
      this.spaceData = response.data;
      this.setTitle();
      if (this.spaceData.space_type === 'video') {
        this.mediaData = this.spaceData && this.spaceData.media && this.spaceData.media.video ? this.spaceData.media.video : [];
      } else {
        this.mediaData = this.spaceData && this.spaceData.media && this.spaceData.media.images ? this.spaceData.media.images : [];
      }

      if (this.mediaData.length === 0) {
        this.router.navigate(['/404']);
      }

      this.floorplanData = this.spaceData && this.spaceData.floorplan ? this.spaceData.floorplan : undefined;
      this.highLightReelData = this.spaceData.highlightReel ? this.spaceData.highlightReel : [];

      if (this.mediaData && this.mediaData.length > 0) {
        const selectedMedia = _.find(this.mediaData, {set_initial_view: 1});
        if (selectedMedia) {
          this.selectedMedia = selectedMedia;
        } else {
          this.selectedMedia = this.mediaData[0];
        }
      }
    }, err => {
      this.router.navigate(['/**']);
      this.spaceData = undefined;
    });
  }

  seletedMediaEmit(response) {
    this.selectedMedia = response;
  }

  // Session for visitors
  // Highlightreel
  startSession() {
    const thisobject = this;
    this.sessionInterval = setInterval( () => {
      thisobject.sessionTime = thisobject.sessionTime + 1;
    }, 1000);
  }

  stopSession() {
    clearInterval(this.sessionInterval);
    this.sessionEnded = true;
  }

  async storeSessionVistorsCount() {
    if (this.sessionTime > 0) {
      const body = {
        ip: await this.ipAddress,
        space_id: await this.spaceId,
        type: 'session',
        time: this.sessionTime
      };
      let formData;
      formData = body;
      formData = this.helperService.updateJsonFormat(formData);
      this.statisticService.getIpDetail(formData).subscribe((res: any) => {
        this.stopSession();
      }, err => {
        console.log(err);
      });
    }
  }

  copyIframeText() {
    setTimeout(() => {
      $('#iframeInput').select();
      document.execCommand('copy');
      $('.copied').text('Copied to clipboard').show().fadeOut(3000);
    }, 100);
  }

  ngOnDestroy() {
    this.storeSessionVistorsCount();
  }

}
